import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  calendar: {
    "&.MuiDateCalendar-root": {
      height: "230px",
      margin: "0",
    },

    "&.MuiDateRangeCalendar-root": {
      gap: "11px",
      [theme.breakpoints.down("mobile")]: {
        gap: 0,
        display: "flex",
        justifyContent: "center",
      },

      '&> div:first-child': {
        display: "none",
      },

      "& [class*=MuiDateRangeCalendar-monthContainer]": {
        border: 0,
        width: "210px",
        [theme.breakpoints.down("mobile")]: {
          width: "320px",
        },

        '&:not(:last-of-type)': {
          borderRight: 'none'
        }
      },
    },

    "& .MuiDayCalendar-root": {
      maxWidth: "100%",
      margin: "0 auto",
    },
    "& .MuiPickersCalendarHeader-root": {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      margin: "0 0 5px",
    },
    "& .MuiPickersCalendarHeader-labelContainer": {
      [theme.breakpoints.down("mobile")]: {
        position: "absolute",
        textTransform: "capitalize",
        fontSize: "11px",
        fontWeight: "400",
      },
    },
    "& .MuiTypography-root": {
      fontSize: "11px",
      fontWeight: 400,
      lineHeight: "normal",
      textTransform: "capitalize",
    },
    "& .MuiPickersArrowSwitcher-root": {
      padding: 0,
      marginBottom: "4px",
      [theme.breakpoints.down("mobile")]: {
        margin: "0 auto",
        padding: 0,
        width: "146px",
        display: "flex",
        justifyContent: "space-between",
      },
    },
    "& .MuiButtonBase-root.MuiIconButton-root.MuiPickersArrowSwitcher-button": {
      padding: "0 8px",
      maxWidth: "24px",
      minHeight: "24px",
    },
    // "& .MuiButtonBase-root.MuiIconButton-root.MuiPickersArrowSwitcher-button:nth-child(1)": {
    //   [theme.breakpoints.down("mobile")]: {
    //     padding: "0 80 0 0px",
    //   },
    // },
    "& .MuiDayCalendar-header": {
      maxWidth: "210px",
      [theme.breakpoints.down("mobile")]: {
        maxWidth: "320px",
      },
    },
    "& .MuiButtonBase-root.MuiIconButton-root.MuiPickersArrowSwitcher-button:after":
      {
        borderRadius: "none",
      },
    "& .MuiDayCalendar-weekContainer": {
      margin: "auto 0",
      height: "22px",
      gap: "8px",
      [theme.breakpoints.down("mobile")]: {
        gap: 0,
      },
    },
    "& .MuiDayCalendar-monthContainer": {
      display: "flex",
      flexDirection: "column",
      columnGap: "8px",
      overflow: "hidden",
      minHeight: "170px",
      width: "210px",
      [theme.breakpoints.down("mobile")]: {
        width: "320px",
      },
    },
    "& .MuiTypography-root.MuiDayCalendar-weekDayLabel": {
      width: "22px",
      height: "22px",
      margin: "auto",
      textAlign: "center",
      fontSize: "11px",
      fontWeight: 400,
      lineHeight: "normal",
    },
    "& .MuiTypography-root.MuiDayCalendar-weekDayLabel:nth-child(6)": {
      color: theme.palette.mainButton.blue,
    },
    "& .MuiTypography-root.MuiDayCalendar-weekDayLabel:nth-child(7)": {
      color: theme.palette.mainButton.blue,
    },
    "& .MuiPickersSlideTransition-root.MuiDayCalendar-slideTransition": {
      minHeight: "172px",
      minWidth: "210px",
      [theme.breakpoints.down("mobile")]: {
        minWidth: "320px",
      },
    },
    "& .MuiPickersDay-root": {
      width: "22px",
      height: "22px",
      margin: "auto",
      textAlign: "center",
      fontSize: "11px",
      fontWeight: 400,
      lineHeight: "normal",
    },
    "& .MuiDateRangePickerDay-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      height: "22px",
      width: "22px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("mobile")]: {
        margin: "0 auto",
      },
    },
    "& .MuiDateRangePickerDay-root:nth-child(6) .MuiDateRangePickerDay-rangeIntervalPreview .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected)":
      {
        color: theme.palette.mainButton.blue,
      },
    "& .MuiDateRangePickerDay-root:nth-child(7) .MuiDateRangePickerDay-rangeIntervalPreview .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected)":
      {
        color: theme.palette.mainButton.blue,
      },
    "& .MuiDateRangePickerDay-rangeIntervalPreview": {
      height: "22px",
      width: "22px",
      display: "flex",
      border: 0,
      margin: "2px",
    },
    "& .MuiButtonBase-root.MuiPickersDay-root.Mui-selected": {
      borderRadius: "4px",
      height: "22px",
      width: "22px",
      background: theme.palette.mainButton.darkBlue,
    },
    "& .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected)": {
      borderRadius: "4px",
    },
  },
  container: {
    width: "100%",
    height: "230px",
    display: "flex",
    gap: "16px",
  },
}));

export default useStyles;
